




import { Component, Prop, Vue, Watch } from 'nuxt-property-decorator'

@Component
export default class ComponentContentScript extends Vue {
  @Prop({ type: String, default: '' }) readonly code!: string
  private injectedScript: HTMLScriptElement | null = null

  private mounted() {
    this.injectScript()
  }

  private beforeDestroy() {
    this.cleanupScript()
  }

  @Watch('code')
  private onCodeChanged() {
    this.injectScript()
  }

  private injectScript() {
    if (!process.client || !this.code) {
      return
    }

    this.cleanupScript()

    const sourceScript = this.parseScriptTag(this.code)
    const script =
      this.buildBitrixLoaderScript(sourceScript) ||
      this.buildGenericScript(sourceScript)

    if (!script) {
      return
    }

    this.injectedScript = script
    this.$el.appendChild(script)
  }

  private cleanupScript() {
    if (this.injectedScript && this.injectedScript.parentNode) {
      this.injectedScript.parentNode.removeChild(this.injectedScript)
    }

    this.injectedScript = null
  }

  private buildGenericScript(
    sourceScript: HTMLScriptElement | null
  ): HTMLScriptElement | null {
    const script = document.createElement('script')
    script.type = 'text/javascript'

    if (sourceScript) {
      Array.from(sourceScript.attributes).forEach((attribute) => {
        script.setAttribute(attribute.name, attribute.value)
      })

      if (sourceScript.src) {
        script.src = sourceScript.src
      }

      script.text = sourceScript.textContent || ''
      return script
    }

    script.text = this.code
    return script
  }

  private buildBitrixLoaderScript(
    sourceScript: HTMLScriptElement | null
  ): HTMLScriptElement | null {
    if (!sourceScript) {
      return null
    }

    const inlineCode = sourceScript.textContent || ''
    const urlMatch = inlineCode.match(
      /https:\/\/b24\.jettools\.ru\/upload\/crm\/form\/loader_[^'"]+\.js/
    )

    if (!urlMatch) {
      return null
    }

    const script = document.createElement('script')
    script.async = true
    script.src = `${urlMatch[0]}?${Math.floor(Date.now() / 180000)}`

    const b24Form = sourceScript.getAttribute('data-b24-form')
    const skipMoving = sourceScript.getAttribute('data-skip-moving')

    if (b24Form) {
      script.setAttribute('data-b24-form', b24Form)
    }

    if (skipMoving) {
      script.setAttribute('data-skip-moving', skipMoving)
    }

    return script
  }

  private parseScriptTag(content: string): HTMLScriptElement | null {
    if (!content.includes('<script')) {
      return null
    }

    const wrapper = document.createElement('div')
    wrapper.innerHTML = content.trim()
    return wrapper.querySelector('script')
  }
}
